/**
 * Billing 도메인 Query Hook Wrapper
 */

import {useQuery} from '@tanstack/react-query';
import {BILLING_QUERY_KEY_MAP} from '../api/billing/constant';
import {billingFactory} from '../factory/billingFactory';

// ============================================
// useBankCodeListQuery
// ============================================

export function useBankCodeListQuery(
  ...args: Parameters<typeof billingFactory.bankCodeList>
) {
  return useQuery(billingFactory.bankCodeList(...args));
}

useBankCodeListQuery.getKey = (
  ...args: Parameters<typeof BILLING_QUERY_KEY_MAP.bankCodeList>
) => [...BILLING_QUERY_KEY_MAP.bankCodeList(...args)];

// ============================================
// useRefundableAmountQuery
// ============================================

export function useRefundableAmountQuery(
  ...args: Parameters<typeof billingFactory.refundableAmount>
) {
  return useQuery(billingFactory.refundableAmount(...args));
}

useRefundableAmountQuery.getKey = (
  ...args: Parameters<typeof BILLING_QUERY_KEY_MAP.refundableAmount>
) => [...BILLING_QUERY_KEY_MAP.refundableAmount(...args)];

// ============================================
// useVerifyBankAccountQuery
// ============================================

export function useVerifyBankAccountQuery(
  ...args: Parameters<typeof billingFactory.verifyBankAccount>
) {
  return useQuery(billingFactory.verifyBankAccount(...args));
}

useVerifyBankAccountQuery.getKey = (
  ...args: Parameters<typeof BILLING_QUERY_KEY_MAP.verifyBankAccount>
) => [...BILLING_QUERY_KEY_MAP.verifyBankAccount(...args)];
